// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1534":"6ababe64","2228":"6ababe64","5423":"2c74ecce","6254":"456a8810","6455":"70756e1c","7957":"0f539407","8688":"5f09114e","9915":"64e0f89b","9962":"c3fae0c5"}[chunkId] + ".chunk.css";
};